export enum ApiTagEnum {
    ORGANIZATIONS = 'Organizations',
    INVITATIONS = 'Invitations',
    DEVELOPER_SETTINGS = 'DeveloperSettings',
    ORGANIZATION_INFO = 'OrganizationInfo',
    VERIFICATION = 'Verification',
    APPLICANTS = 'Applicants',
    APPLICANT_ALERTS = 'ApplicantAlerts',
    APPLICANT = 'Applicant',
    FILE_UPLOADS = 'FileUploads',
    PEPS = 'Peps',
    CONTACT_US = 'ContactUs',
    LIST_TEAM = 'ListTeam',
    CURRENT_ORGANIZATION = 'Current Organization',
    CURRENT_BILLING_ORGANIZATION = 'Current Billing Organization',
    REAL_TIME_BALANCE = 'RealTimeBalance',
    PEP = 'PEP',
    UPDATE_PROFILE = 'UPDATE_PROFILE',
    VERIFICATION_FLOW = 'VERIFICATION_FLOW',
    DEEPFAKE_JOBS = 'DEEPFAKE_JOBS',
    KYT_CHECKS = 'KYT_CHECKS',
}
